/**
 * CreateCustomerDialog - Dialog zum Anlegen eines neuen Kunden
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { PhoneInput } from '@/components/ui/phone-input';
import { Plus } from 'lucide-react';

const CreateCustomerDialog = ({
  open,
  onOpenChange,
  formData,
  setFormData,
  onSubmit
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button data-testid="create-customer-button">
          <Plus size={16} className="mr-2" />
          Neuer Kunde
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Neuen Kunden anlegen</DialogTitle>
          <p className="text-sm text-gray-600 mt-2">
            Der Kunde erhält eine E-Mail und WhatsApp-Nachricht mit einem Link zur Bestätigung der AGB und Unterschrift.
          </p>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="first_name">Vorname</Label>
              <Input
                id="first_name"
                data-testid="customer-firstname-input"
                value={formData.first_name}
                onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="last_name">Nachname</Label>
              <Input
                id="last_name"
                data-testid="customer-lastname-input"
                value={formData.last_name}
                onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                required
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="email">E-Mail</Label>
            <Input
              id="email"
              data-testid="customer-email-input"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="phone">Mobile</Label>
            <PhoneInput
              id="phone"
              data-testid="customer-phone-input"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="date_of_birth">Geburtsdatum</Label>
            <Input
              id="date_of_birth"
              type="date"
              value={formData.date_of_birth}
              onChange={(e) => setFormData({ ...formData, date_of_birth: e.target.value })}
              required
            />
          </div>
          
          {/* Geschlecht Auswahl */}
          <div className="space-y-2">
            <Label>Geschlecht *</Label>
            <div className="flex gap-3">
              <Button
                type="button"
                data-testid="customer-gender-male"
                variant={formData.gender === 'male' ? 'default' : 'outline'}
                onClick={() => setFormData({ ...formData, gender: 'male' })}
                className={`flex-1 ${formData.gender === 'male' ? 'bg-yellow-500 text-black hover:bg-yellow-600' : ''}`}
              >
                ♂ Mann
              </Button>
              <Button
                type="button"
                data-testid="customer-gender-female"
                variant={formData.gender === 'female' ? 'default' : 'outline'}
                onClick={() => setFormData({ ...formData, gender: 'female' })}
                className={`flex-1 ${formData.gender === 'female' ? 'bg-yellow-500 text-black hover:bg-yellow-600' : ''}`}
              >
                ♀ Frau
              </Button>
            </div>
          </div>
          
          <Button type="submit" className="w-full" data-testid="submit-customer-button">
            Kunde erstellen & Verifizierungs-Link senden
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CreateCustomerDialog;
